// extracted by mini-css-extract-plugin
export var checked = "marginBottomFlexible-module--checked--4d819";
export var marginBig = "marginBottomFlexible-module--marginBig--2e29a";
export var marginMedium = "marginBottomFlexible-module--marginMedium--4cf91";
export var marginSmall = "marginBottomFlexible-module--marginSmall--60a16";
export var unchecked = "marginBottomFlexible-module--unchecked--6cf7e";